import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const registerByEmail = params => {
  return ApiService.post(`user`, params);
};

export const withdrawById = params => {
  return ApiService.delete(`user/profile/${params.id}`);
};

export const UpdateMe = payload => {
  return ApiService.put(`user/profile/me`, payload);
};

export const registerOwner = params => {
  return ApiService.post(`user/ceo`, params);
};

export const modifyOwnerProfile = params => {
  return ApiService.multiPut(`user/ceo/profile/me`, params);
};

export const syncOwnerProfile = params => {
  return ApiService.post(`user/ceo/profile/sync/${params.id}`);
};

export const syncOwnerProfileMe = params => {
  return ApiService.post(`user/ceo/profile/sync/me`);
};

export const saveDeviceInfo = params => {
  return ApiService.put(`user/device`, params);
};

export const removeDeviceInfo = params => {
  return ApiService.delete(`user/device`, params);
};

export const checkExistEmail = params => {
  return ApiService.query(`user/exist/email?${stringify(params)}`, {
    //isErrToast: true,
    isErrMsg: false,
  });
};

export const checkExistNickname = params => {
  return ApiService.query(`user/exist/nickname?${stringify(params)}`, {
    isErrToast: true,
  });
};

export const checkExistUsername = params => {
  return ApiService.query(`user/exist/username?${stringify(params)}`);
};

export const registerFromMobile = params => {
  return ApiService.post(`user/mobile`, params);
};

export const resetPasswordById = params => {
  return ApiService.put(`user/password/${params.id}/reset`, params);
};

export const findPasswordForEmailUser = params => {
  return ApiService.post(`user/password/find`, params);
};

export const findPasswordForPhoneUser = params => {
  return ApiService.post(`user/password/find/reset`, params);
};

export const resetCurrentPassword = params => {
  return ApiService.put(`user/password/me/reset`, params);
};

export const resetPassword = params => {
  return ApiService.post(`user/password/reset`, params);
};

export const confirmPasswordCode = params => {
  return ApiService.query(`user/password/reset/${params.code}`);
};

export const updatePasswordDate = params => {
  return ApiService.put(`user/password/updatedat/reset`, params);
};

export const getUserStatus = params => {
  return ApiService.query(`user/status/${params.id}`);
};

export const getProfile = params => {
  return ApiService.query(`user/profile/${params.id}`);
};

export const modifyProfile = params => {
  return ApiService.put(`user/profile/${params.id}`, params);
};

export const getMyProfile = params => {
  return ApiService.query(`user/profile/me`, {
    isLoading: false,
  });
};

export const modifyMyProfile = params => {
  return ApiService.put(`user/profile/me`, params);
};

export const setArea = params => {
  return ApiService.put(`user/profile/me/area`, params);
};

export const setUserData = params => {
  return ApiService.put(`user/profile/userData`, params);
};

export const changeEmail = params => {
  return ApiService.put(`user/profile/me/email`, params);
};

export const changePhoneNumber = params => {
  return ApiService.put(`user/profile/me/mobileNumber`, params);
};

export const findUser = params => {
  return ApiService.query(`user/search?${stringify(params)}`);
};

export const findOwnerUser = params => {
  return ApiService.query(`user/owner/search?${stringify(params)}`);
};

export const findId = params => {
  return ApiService.post(`user/userid/find`, params);
};

export const FindUserByMobileNumber = params => {
  return ApiService.post(`user/mobileNumber/find`, params, { isErrMsg: false });
};
export const FindUserByUserId = params => {
  return ApiService.post(`user/userid/find`, params, { isErrMsg: false });
};

export const downloadOwnerExcel = params => {
  return ApiService.file(`user/owner/search/excel?${stringify(params)}`);
};

export const downloadUserExcel = params => {
  return ApiService.file(`user/search/excel?${stringify(params)}`);
};

export const updateCurrentArea = params => {
  return ApiService.put(`user/profile/me/currentArea`, params, {
    isErrMsg: false,
  });
};

export const getAuthAreaMe = () => {
  return ApiService.query('user/authArea/me');
};

export const getAuthArea = params => {
  return ApiService.query(`user/authArea/${params.id}`);
};

export const modifyPassword = params => {
  return ApiService.put(`user/password/${params.id}/reset`, params);
};

export const updateUserTelecomDevice = params => {
  return ApiService.put(`user/telecomDevice`, params);
};

export const updateUserTelecomAndDevice = params => {
  return ApiService.put(`user/profile/telecomAndDevice`, params);
};

export const getUserDevice = params => {
  return ApiService.query(`user/device/${params.id}`);
};

export const setCounsel = params => {
  // console.log('setCounsel');
  // console.log(params);
  return ApiService.put(`user/ceo/profile/counsel`, params);
};
export const getUserInfo = params => {
  return ApiService.query(`user/userInfo/${params.id}`);
};
export const updateUserNickname = params => {
  return ApiService.put(`user/nickname?${stringify(params)}`);
};

export const getUserViolation = () => {
  return ApiService.query('user/rulesViolation/me');
};

export const setUserReport = params => {
  return ApiService.post(`user/report`, params);
};

export const getUserCurrentArea = params => {
  return ApiService.query(`user/currentArea?${stringify(params)}`);
};

export const setUserCurrentArea = params => {
  return ApiService.post(`user/currentArea`, params);
};
